"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeChart = void 0;
var getIndexNearest_1 = require("../../common/getIndexNearest");
var createSvg_1 = require("../createSvg");
var drawPlane_1 = require("../parse/drawPlane");
var getPlanes_1 = require("../parse/getPlanes");
var RangeChart = function (svg, config) {
    var BAR_BODY_WIDTH = config.thickness || 8;
    var BAR_HANDLE_WIDTH = BAR_BODY_WIDTH;
    var BAR_HANDLE_HEIGHT = 2;
    var innerPaddingStart = config.xAxis.innerPaddingStart || 0;
    var _a = getPlanes_1.getPlanes(config), dataPointGroup = _a.dataPointGroup, yAxisMarks = _a.yAxisMarks, destPlane = _a.destPlane;
    var pairs = dataPointGroup[0];
    drawPlane_1.drawPlane(svg, config, pairs, yAxisMarks, destPlane);
    if (config.hasLine) {
        var firstDataPointGroup = dataPointGroup[0].map(function (it) { return [it[0][0] + BAR_HANDLE_WIDTH / 2, it[1][1] + (it[0][1] - it[1][1]) / 2]; });
        var path = firstDataPointGroup.map(function (it) { return "L " + it[0] + " " + it[1]; }).join(' ');
        var newPath = "M" + path.substr(1);
        svg.path(newPath).stroke({ color: config.values[0].color2, width: 2 }).fill('transparent');
    }
    if (config.selectedIndex > -1) {
        var selectLine = destPlane[1];
        var newX = Math.floor(pairs[config.selectedIndex][0][0] + (BAR_BODY_WIDTH || 6) / 2);
        selectLine[0][0] = newX;
        selectLine[1][0] = newX;
        svg.line(selectLine).stroke({ color: config.selectedLineColor, width: 1 });
    }
    pairs.map(function (it, i) {
        var color = (i === config.selectedIndex && config.values[0].color2) ? config.values[0].color2 : config.values[0].color;
        var min = it[0];
        var max = it[1];
        svg.rect(BAR_HANDLE_WIDTH, BAR_HANDLE_HEIGHT).move(min[0], min[1]).fill(color);
        svg.rect(BAR_HANDLE_WIDTH, BAR_HANDLE_HEIGHT).move(max[0], max[1]).fill(color);
        svg.rect(BAR_BODY_WIDTH, min[1] - max[1]).move(max[0] + (BAR_HANDLE_WIDTH - BAR_BODY_WIDTH) / 2, max[1]).fill(color);
    });
    var maxPoints = pairs.map(function (it) { return it[1]; });
    var getXY = function (x, y) { return getIndexNearest_1.getIndexNearest([maxPoints], BAR_BODY_WIDTH, x, y); };
    var getPopupInfo = function (i) {
        var color = config.values[0].color;
        var title = config.yAxis.label2 ? config.yAxis.label2 : config.yAxis.label;
        var value = createSvg_1.comma(config.values[0].series[i][0]) + " - " + createSvg_1.comma(config.values[0].series[i][1]);
        return {
            title: config.xAxis.series[i],
            rows: [{ color: color, title: title, value: value }]
        };
    };
    var getDataPointGroup = function () { return dataPointGroup; };
    return { svg: svg, getXY: getXY, getPopupInfo: getPopupInfo, getDataPointGroup: getDataPointGroup };
};
exports.RangeChart = RangeChart;
